import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, LinearProgress, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import { JudulKarya } from "./pra-sidang/JudulKarya";
import { SIDANG_TYPE } from "../../../utils/constants/SidangType.constants";
import { useLocation, useNavigate } from "react-router-dom";
import MKSpesialJadwalSidang from "./pra-sidang/jadwal-sidang/MKSpesialJadwalSidang";
import MKSpesialPengumpulanBerkas from "./pra-sidang/pengumpulan-berkas/MKSpesialPengumpulanBerkas";
import MKSpesialStatusIzinMajuSidang from "./pra-sidang/status-izin-maju/MKSpesialStatusIzinMajuSidang";
import MKSpesialService from "../../../services/Integration/mkspesial/MKSpesialService";
import RevisiMahasiswa from "./post-sidang/RevisiMahasiswa";
import BerkasFinal from "./post-sidang/BerkasFinal";
import PeerReview from "./post-sidang/PeerReview";
import DeadlineService from "../../../services/Integration/deadline/DeadlineService";

import "./Sidang.css";

export default function Sidang({ mKSpesialId, jenisSidang }) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState("1");
  const [mKSpesial, setMKSpesial] = useState({});
  const [deadlines, setDeadlines] = useState({});

  useEffect(() => getMKSpesialDetails(), []);

  const getMKSpesialDetails = async () => {
    setIsLoading(true);
    await MKSpesialService.getMKSpesialByID(mKSpesialId).then((response) => {
      if (response.status === 200) {
        setMKSpesial(response.data);
      } else {
        console.log(response);
      }
    });
    await DeadlineService.getDeadlinesList(jenisSidang)
      .then((response) => {
        if (response.status !== 200) {
          console.log("Fail to fetch deadline.");
          return;
        }
        setDeadlines(response.data);
      })
      .catch((error) => console.log(error));
    if (state.tabIndex === "6") {
      setTabIndex("6");
    }
    setIsLoading(false);
  };

  const handleTabIndexChange = (e, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <div className="mt-4">
      {isLoading ? (
        <LinearProgress />
      ) : (
        <>
          <div className="mb-1">
            <small>
              <span className="font-bold">Note: </span>Silakan{" "}
              <button
                className="text-blue-500 hover:underline"
                onClick={() => navigate(0)}
              >
                <i>refresh</i>
              </button>{" "}
              halaman ini jika <i>styling</i> kurang benar.
            </small>
          </div>
          <span>{mKSpesial.jenis_sidang}</span>
          <JudulKarya
            mKSpesial={mKSpesial}
            refreshMKSpesial={getMKSpesialDetails}
          />
          <TabContext value={tabIndex}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleTabIndexChange}>
                <Tab label="Pengumpulan Berkas" value={"1"} />
                <Tab label="Status Perizinan Maju Sidang" value={"2"} />
                <Tab label="Jadwal Sidang" value={"3"} />
                <Tab label="Revisi Berkas" value={"4"} />
                <Tab label="Berkas Final" value={"5"} />
                {jenisSidang === SIDANG_TYPE["Tugas Akhir Kelompok"] && (
                  <Tab label="Peer Review" value={"6"} />
                )}
              </TabList>
            </Box>
            <TabPanel value={"1"} sx={{ padding: 0 }}>
              <MKSpesialPengumpulanBerkas
                mKSpesial={mKSpesial}
                deadlines={deadlines}
              />
            </TabPanel>
            <TabPanel value={"2"} sx={{ padding: 1 }}>
              <MKSpesialStatusIzinMajuSidang mKSpesial={mKSpesial} />
            </TabPanel>
            <TabPanel value={"3"} sx={{ padding: 1 }}>
              <MKSpesialJadwalSidang mKSpesialId={mKSpesialId} />
            </TabPanel>
            <TabPanel value={"4"} sx={{ padding: 1 }}>
              <RevisiMahasiswa mKSpesialId={mKSpesialId} />
            </TabPanel>
            <TabPanel value={"5"} sx={{ padding: 1 }}>
              <BerkasFinal mKSpesialId={mKSpesialId} deadlines={deadlines} kodeStatus={mKSpesial.status.kode} />
            </TabPanel>
            {jenisSidang === SIDANG_TYPE["Tugas Akhir Kelompok"] && (
              <TabPanel value={"6"} sx={{ padding: 1 }}>
                <PeerReview
                  kelompok={mKSpesial.mahasiswa}
                  mkSpesialId={mKSpesialId}
                  isLoading0={isLoading}
                />
              </TabPanel>
            )}
          </TabContext>
        </>
      )}
    </div>
  );
}
